﻿import { SaopWebGrid,SaopWebGridProperties,SaopWebGridToolbar,SaopWebGridToolbarButton,SaopWebDataTable} from "../Components/saop-grid";

export class KeEployeeLeaveListGrid {
  private libName:string;
  private _mainFormDiv:JQuery<HTMLElement>;
  private _searchValue:JQuery<HTMLElement>;
  //
  public webGrid1:SaopWebGrid;

  constructor(libName: string) {
    this.libName = libName;
  }  

  initView(){
    this._mainFormDiv = $("#KeEmployeeLeaveListBrowseForm");
    this.initWebGrid1();
    this._searchValue = this._mainFormDiv.find("#SearchValue");  
    this.initFilterControls();     
  }

  initWebGrid1(){
    let wgId = "#KeEmployeeLeaveList";
    let captionToolbar = $(wgId).attr("caption-toolbar");
    let toolbarItemsTemplateId = $(wgId).attr("toolbar-items-templateId");
    //
    this.webGrid1 = new SaopWebGrid(this.libName+".webGrid1");
    let gridProperties: SaopWebGridProperties;
    let gridToolbar:SaopWebGridToolbar;
    let toolbarButtons:SaopWebGridToolbarButton[] = [];
    let dataTable:SaopWebDataTable;
    //
    gridToolbar = {caption:captionToolbar,buttons:toolbarButtons,itemsTemplateId:toolbarItemsTemplateId};
   
    dataTable = {enabled:true}

    gridProperties = {
        gridId:wgId
        ,togglePanel:{enabled:false}
        ,toolbar:gridToolbar
        ,dataTable:dataTable
      };        
    //
    this.webGrid1.init(gridProperties);   
   
  }

  initFilterControls(): void {
    let _this = this;
    this._searchValue.keyup(function () {
        let oTable = _this.webGrid1.dataTable;
        oTable.search($(this).val().toString()).draw() ;           
    });    
  }

}






